import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { GoogleOAuthProvider } from '@react-oauth/google'; // Import GoogleOAuthProvider

// Thêm Google Client ID ở đây
const clientId = '965179083320-352kf6i7nrvu5lqv7ks0nvrl2vfe8m8p.apps.googleusercontent.com'; // Thay thế bằng Client ID của bạn từ Google Developer Console
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <GoogleOAuthProvider clientId={clientId}> {/* Bọc toàn bộ ứng dụng trong GoogleOAuthProvider */}
      <App />
    </GoogleOAuthProvider>
  </React.StrictMode>
);

reportWebVitals();